import { ResStatus } from 'api/api.types';
import { AxiosResponse } from 'axios';

export const getIds = (item: any) =>
  Array.isArray(item) ? item.map((i) => i.id) : item.id;

export const isSuccessful = (
  res: AxiosResponse<
    {
      status: ResStatus;
      message: string;
      data: { status: string };
    },
    any
  >,
) => res.data.status === ResStatus.OK;

export const getCustomerId = (customer: any): number | null => {
  if (!customer) return null;

  if (customer.businessFunctions && Array.isArray(customer.businessFunctions)) {
    const customerFunction = customer.businessFunctions.find(
      (businessFunction: any) => businessFunction.__type === 'Customer',
    );
    if (customerFunction) {
      return customerFunction.id;
    }
  }

  return getIds(customer);
};

export const getTruckerId = (trucker: any): number | null => {
  if (!trucker) return null;

  if (trucker.businessFunctions && Array.isArray(trucker.businessFunctions)) {
    const truckerFunction = trucker.businessFunctions.find(
      (businessFunction: any) => businessFunction.__type === 'Trucker',
    );
    if (truckerFunction) {
      return truckerFunction.id;
    }
  }
  return getIds(trucker);
};
